import BaseModal from '@c/modals/BaseModal';
import { useQueryClient } from '@tanstack/react-query';
import Select from '@ui/Select';
import { removeUndefinedRecursive } from '@util/firestore/products';
import { addUserSizes } from '@util/firestore/users';
import { useToastContext } from 'context/ToastContext';
import { BootsIcon } from 'i/measurement/boot-icon';
import { GearIcon } from 'i/measurement/gear-icon';
import { HelmetIcon } from 'i/measurement/helmet-icon';
import { UserDocument, UserSizes } from 'models/user';
import { useState } from 'react';
import { LETTER_SIZES, PANT_SIZES, BOOT_SIZES } from 'models/shared';
import PantIcon from 'i/measurement/pant-icon';
import EditSizesForm from './forms/EditSizesForm';

type EditSizesModalProps = {
  isOpen: boolean;
  dismiss: () => void;
  userDoc: UserDocument;
};

export default function EditSizesModal({
  isOpen,
  dismiss,
  userDoc,
}: EditSizesModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={dismiss}
      title="My Sizes"
      overflowType="visible"
    >
      <EditSizesForm dismiss={dismiss} userDoc={userDoc} />
    </BaseModal>
  );
}
